<template>
    <div class="header">
        <v-app-bar
                min-height="'137px'"
                color="white"
                clipped-right
                height="70"
                fixed
        >
            <v-icon color="primary"
                    size="40"
                    @click="drawer = !drawer">fas fa-bars
            </v-icon>
            <v-spacer></v-spacer>
            <div class="d-flex align-center">
<!--                <v-img-->
<!--                        alt="mai"-->
<!--                        class="shrink"-->
<!--                        contain-->
<!--                        :src="logoSrc"-->
<!--                        transition="scale-transition"-->
<!--                        width="40"-->
<!--                />-->
            </div>
        </v-app-bar>
        <v-navigation-drawer
                v-model="drawer"
                width="100%"
                clipped
                absolute
                height="'539px'">
            <v-sheet color="primary"
                     tile
                     class="white--text ps-12 userData" height="70">{{userName}} שלום,
            </v-sheet>
            <v-list class="px-4 py-0">
                <template v-for="(item,index) in items">
                    <v-divider v-if="item.divider" :key="index"></v-divider>
                    <v-list-item
                            v-else-if="item.routerLink"
                            class="ps-10 my-0 py-1"
                            color="primary"
                            :key="item.title"
                            tile
                            link
                            :to="item.url"
                    >
                        <v-list-item-icon class="ml-7">
                            <v-icon color="primary" size="20">{{item.icon}}</v-icon></v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>{{ item.title }}</v-list-item-title>
                        </v-list-item-content>

                    </v-list-item>
                    <v-list-item

                            class="ps-10 my-0 py-1"
                            color="primary"
                            :key="item.title"
                            tile
                            link
                            v-else-if="item.hideForUsers"
                            :href="item.url"
                    >
                        <v-list-item-icon class="ml-7">
                            <v-icon color="primary" size="20">{{item.icon}}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>{{ item.title }}
                            </v-list-item-title>
                        </v-list-item-content>

                    </v-list-item>
                    <v-list-item

                        class="ps-10 my-0 py-1"
                        color="primary"
                        :key="item.title"
                        tile
                        link
                        v-else-if="item.method"
                        @click="refreshScreen()"
                    >
                        <v-list-item-icon class="ml-7">
                            <v-icon color="primary" size="20">{{item.icon}}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>{{ item.title }}</v-list-item-title>
                        </v-list-item-content>

                    </v-list-item>
                    <v-list-item

                            class="ps-10 my-0 py-1"
                            color="primary"
                            :key="item.title"
                            tile
                            link
                            v-else-if="!item.hideForUsers"
                            :href="item.url"
                    >
                        <v-list-item-icon class="ml-7">
                            <v-icon color="primary" size="20">{{item.icon}}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>{{ item.title }}</v-list-item-title>
                        </v-list-item-content>

                    </v-list-item>
                </template>
            </v-list>
        </v-navigation-drawer>

    </div>
</template>

<script>

    export default {
        name: "vHeader",
        data: () => {
            return {
                userName: window.localStorage.getItem('Name')?window.localStorage.getItem('Name'):'',
                drawer: false,
                group: null,
                items: [

                    {title: 'רענן אפליקציה', icon: 'fas fa-sync', method: 'refresh', routerLink: false},
                    {divider: true, inset: true},
                    {title: 'משלוחים של היום', icon: 'fas fa-play', url: '/', routerLink: false, hideForUsers: false},
                    {divider: true, inset: true},
                    {title: 'משלוחים של מחר', icon: 'fas fa-forward', url: '/?day=tomorrow', routerLink: false, hideForUsers: false},
                    {divider: true, inset: true},
                    {title: 'צור קשר', icon: 'fas fa-phone', url: 'tel:0523708525', routerLink: false},
                    {divider: true, inset: true},
                    {title: 'התנתק', icon: 'fas fa-sign-out-alt', url: '/logout', routerLink: true},
                ]
            }
        },
        methods: {
            checkUserType: function() {
                return window.localStorage.getItem('role') === 'admin';
            },
            refreshScreen: function() {
                window.location.reload(true);
            },
        },
        computed: {
        },
        watch: {
            group() {
                this.drawer = false
            },
        },
    }
</script>

<style scoped lang="scss">
    .userData {
        font-size: 19px;
        font-weight: 500;
        text-align: right;
        color: #ffffff;
        display: flex;
        align-items: center;
    }

    aside {
        top: 70px !important;
    }
</style>
